import React from "react";
import Header from "./partials/header";
import Footer from "./partials/footer";
import styled from "styled-components";
import mainbackground from "../assets/images/background/mainbackground.png";
import MargetBackgroundImage from "../assets/images/background/marketBakgroundImage.png";
import PreviewPackBackgroundImage from "../assets/images/background/previewPackBackground.png";
import RouletteBackgroundImage from "../assets/images/background/rouletteBackground.png";
import JoinRouletteBackgroundImage from "../assets/images/background/joinRouletteBackground.png";
// import BallcanoBackgroundImage from "../assets/images/background/ballcanoBg.png";
import { useLocation } from "react-router-dom";
import useHeader from "../hooks/useHeader";
import BattleBackgroundImage from "../assets/images/background/battlebackground.png";

const Main = styled.div`
   width: 100%;
   height: 100%;
   display: flex;
   align-items: center;
   justify-content: center;
   /* position: fixed; */
`
const ContentContainer = styled.div`
  width: 100%;
  height: 100%;
  max-width: 420px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
`
const BackgroundImage = styled.img`
    position: absolute;
    width: 100%;
    height: 100%;
    object-fit: fill;
`
const Layout = ({ children}) => {
    const location = useLocation();
    const Header = useHeader(location.pathname);
    let backgroundImage =  mainbackground;
    
    switch (location.pathname) {

        case "/game":
            backgroundImage = null;
            break; 
        case "/previewPack":
            backgroundImage = PreviewPackBackgroundImage;
            break;
        case "/openedPack":
            backgroundImage = null;
            break; 
        case "/ballcano":
            backgroundImage = null;
            break; 
        case "/market":
            backgroundImage = MargetBackgroundImage;
            break; 
        case "/roulette":
        backgroundImage = RouletteBackgroundImage;
        break; 
        case "/roulette/join":
        backgroundImage = JoinRouletteBackgroundImage;
        break; 
        case "/battle":
            backgroundImage = BattleBackgroundImage;
            break;
        default:
            backgroundImage = mainbackground;
    }
    // const backgroundImage = location.pathname === "/game" || location.pathname === "/openedPack" ? null  : location.pathname === "/market" ? MargetBackgroundImage : mainbackground;
    // const hasHeader = location.pathname !== "/presale";
    // const hasFooter = location.pathname !== "/presale" ;
    return (
        <Main>
            <ContentContainer>
                {Header}
                {backgroundImage && 
                     <BackgroundImage src={backgroundImage} alt="Main Background" />
                }
                {children}
             {location.pathname !== "/market" && location.pathname !== "/roulette/join" && location.pathname !=="/login" &&
                <Footer/>
                } 
            </ContentContainer>
        </Main>
    );
}
export default Layout;